<template>
	<div class="cusbtn2" @click="btnClick">
		<span>{{ value }}</span>
	</div>
</template>
<script>
export default {
	name: "cusBtn2",
	props: {
		value: {
			type: String,
			default: () => {
				return "上报";
			},
		},
	},
	data() {
		return {};
	},
	methods: {
		btnClick() {
			this.$emit("click");
		},
	},
};
</script>
<style lang="less" scoped>
.cusbtn2 {
	width: 100%;
	height: 40px;
	background: rgba(54, 179, 116, 1);
	border-radius: 3px;
	text-align: center;
	line-height: 40px;
	span {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
	}
}
</style>
